module.exports = __webpack_public_path__ + "img/electric-mining-drill-N-patch.54620bb2.png";